import Button from 'components/Button';
import Icon from 'components/Icon';
import PageLayout from 'components/PageLayout';
import SectionHeader from 'components/SectionHeader';
import {FC} from 'react';
import {t} from 'ttag';

interface Props {
    showBackButton?: boolean;
}

const Base404: FC<Props> = ({showBackButton = true}) => {
    const onClick = () => {
        window.history.back();
    };

    return (
        <PageLayout headerProps={{className: 'pl-2 pb-3 mt-[15vh]'}}>
            <div className="items-center">
                <div className="rounded-lg border border-grey-300 bg-white px-6 pb-8 pt-6 shadow-lg">
                    <div className="flex flex-row items-center py-2">
                        <Icon
                            className="mr-2 flex text-coral-700"
                            icon="danger"
                        />
                        <SectionHeader
                            className="mt-0 flex-1"
                            classNameTitle="flex-1"
                            hideHR={true}
                            title={t`Page not found`}
                        />
                    </div>
                    <div className="flex flex-col gap-y-4 px-8 pb-4">
                        <p>{t`We're sorry, but the requested page is not available. This page might not exist, or you may not have permission to see it.`}</p>
                    </div>
                    {showBackButton && window.history.length > 1 && (
                        <div className="flex w-full flex-row items-end justify-end pt-6">
                            <Button
                                kind="secondary"
                                onClick={onClick}
                                size="base"
                            >{t`Back`}</Button>
                        </div>
                    )}
                </div>
            </div>
        </PageLayout>
    );
};

export default Base404;
